/** Existing displayed declaration; this is not an approved organisational privacy policy. */
export const INTAKE_CONSENT_STATEMENT_VERSION = "intake-declaration-2026-10-25" as const;
const TEXT = {
  fr: "J'accepte la collecte de mes informations conformément à la Loi 25 du Québec.",
  en: "I consent to the collection of my information in accordance with Quebec's Law 25.",
} as const;
export function intakeConsentStatement(language: "fr" | "en") {
  return { version: INTAKE_CONSENT_STATEMENT_VERSION, language, text: TEXT[language] };
}
